module.exports = __webpack_public_path__ + "img/share_email_hover.2e3df737.svg";